ACC.lumifybanner = {
  isFormValid: true,
  formFieldWrap: '.ph-form__fieldwrap',
  formStatusSubmit: '.ph-lumify-contact-form-status-submit',
  formStatusError: '.ph-lumify-contact-form-status-error',
  formStatusClose: '.ph-lumify-contact-form-status-close',
  formRadioLabelErr: 'ph-lumify-banner-radio-label-error',
  formRadioBorderErr: 'ph-lumify-banner-radio-border-error',
  formRadioEmptyCls: '.ph-lumify-contact-radio-empty',
  formCheckMark: '.ph-checkmark',
  buttonPopup: function() {
    $('.ph-lumify-contact-popup').click(function(e) {
      e.preventDefault();
      $.colorbox({
        inline: true,
        href: '#ph-lumify-contact-form',
        height: '100%',
        width: '100%',
        maxWidth: 640,
        maxHeight: '70%',
        overlayClose: false,
        scrolling: true,
        escKey: false,
        close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
        onComplete: function() {
          ACC.lumifybanner.formReset();
          ACC.lumifybanner.formValidationBlur();
          ACC.lumifybanner.formValidationFocus();
          ACC.lumifybanner.formvalidationFocusRadio();
          ACC.lumifybanner.formSubmit();
          ACC.lumifybanner.formCancel();
        }
      });
      $('#cboxLoadingGraphic').show();
      $('#cboxLoadingOverlay').show();
    });
  },
  formValidationBlur: function() {
    $('.ph-lumify-contact-form-contents .ph-forminput').blur(function() {
      var $inputField = $(this),
          inputValue = $inputField.val(),
          $fieldWrap = $inputField.parents(ACC.lumifybanner.formFieldWrap),
          errorClass = 'form_field_error ph-form_field_error',
          errorMsgClass = '.ph-lumify-contact-input-empty';

      function showError() {
        $fieldWrap.addClass(errorClass);
        $fieldWrap.find(errorMsgClass).removeClass('hidden');
        ACC.lumifybanner.isFormValid = false;
      }

      if (typeof $inputField.attr('required') !== 'undefined') {
        if (inputValue.length === 0) {
          showError();
        } else {
          $fieldWrap.removeClass(errorClass);
          $fieldWrap.find(errorMsgClass).addClass('hidden');

          if ($inputField.attr('id') === 'lumify-contact-form-phone' && ACC.validation.phoneNumber(inputValue)) {
            showError();
          }

          if ($inputField.attr('id') === 'lumify-contact-form-email' && ACC.validation.email(inputValue)) {
            showError();
          }
        }
      }
    });
  },
  formValidationFocus: function() {
    $('.ph-lumify-contact-form-contents .ph-forminput').focus(function() {
      var $fieldWrap = $(this).parents(ACC.lumifybanner.formFieldWrap),
          errorMsgClass = '.ph-lumify-contact-input-empty';

      $fieldWrap.find(errorMsgClass).addClass('hidden');
    });
  },
  formvalidationFocusRadio: function() {
    $('.ph-lumify-contact-form input[type="radio"]').focus(function() {
      var $labelWrpper = $(this).parents('.ph-lumify-contact-form-radio-wrapper').find('label');

      $labelWrpper.removeClass(ACC.lumifybanner.formRadioLabelErr);
      $labelWrpper.find(ACC.lumifybanner.formCheckMark).removeClass(ACC.lumifybanner.formRadioBorderErr);
      $labelWrpper.parent().find(ACC.lumifybanner.formRadioEmptyCls).addClass('hidden');
    });
  },
  formValidationRadio: function(inputName) {
    var radioBtnValue = $('.ph-lumify-contact-form input[name="' + inputName + '"]:checked').attr('data-radio-value');

    if (typeof radioBtnValue === 'undefined') {
      var $labelWrpper = $('.ph-lumify-contact-form input[name="' + inputName + '"]').parents('label');

      radioBtnValue = '';
      ACC.lumifybanner.isFormValid = false;
      $labelWrpper.addClass(ACC.lumifybanner.formRadioLabelErr);
      $labelWrpper.find(ACC.lumifybanner.formCheckMark).addClass(ACC.lumifybanner.formRadioBorderErr);
      $labelWrpper.parent().find(ACC.lumifybanner.formRadioEmptyCls).removeClass('hidden');
    }

    return radioBtnValue;
  },
  formValidationInput: function() {
    var $inputFieldObj = $('.ph-lumify-contact-form input');

    $inputFieldObj.trigger('blur');
  },
  formReset: function() {
    var $formObj = $('.ph-lumify-contact-form'),
        $labelWrpper = $formObj.find('input[type="radio"]').parents('label'),
        $inputField = $formObj.find('input'),
        $inputWrapper = $inputField.parents(ACC.lumifybanner.formFieldWrap);

    ACC.lumifybanner.isFormValid = false;
    $formObj.find('input[type="radio"]:checked').prop('checked', false);
    $labelWrpper.removeClass(ACC.lumifybanner.formRadioLabelErr);
    $labelWrpper.find(ACC.lumifybanner.formCheckMark).removeClass(ACC.lumifybanner.formRadioBorderErr);
    $labelWrpper.parent().find(ACC.lumifybanner.formRadioEmptyCls).addClass('hidden');

    $inputField.val('');
    $inputWrapper.removeClass('form_field_error ph-form_field_error');
    $inputWrapper.find('ph-lumify-contact-input-empty').addClass('hidden');

    $formObj.find('textarea').val('');

    $formObj.find('#lumify-contact-form-tnc').prop('checked', false);
    $formObj.find('#lumify-contact-form-newsletter').prop('checked', false);
    $formObj.find('.ph-lumify-contact-tnc-empty').addClass('hidden');
    $(ACC.lumifybanner.formStatusSubmit).html('');
    $(ACC.lumifybanner.formStatusError).html('');
    $(ACC.lumifybanner.formStatusClose).addClass('hidden');
    $('.ph-lumify-contact-form-contents').removeClass('hidden');
  },
  updateFormData: function(formData, $formObj) {
    formData.salutation = ACC.lumifybanner.formValidationRadio('salutation');
    formData.firstName = $formObj.find('#lumify-contact-form-firstName').val();
    formData.LastName = $formObj.find('#lumify-contact-form-lastname').val();
    formData.emailAddress = $formObj.find('#lumify-contact-form-email').val();
    formData.BusinessPhone = $formObj.find('#lumify-contact-form-phone').val();
    formData.company = $formObj.find('#lumify-contact-form-company').val();
    formData.title = $formObj.find('#lumify-contact-form-job').val();

    return formData;
  },
  formSubmit: function() {
    $('.ph-lumify-contact-form-contents__button-submit').click(function() {
      ACC.lumifybanner.isFormValid = true;

      var successText = $(ACC.lumifybanner.formStatusSubmit).attr('data-success-text'),
          errorText = $(ACC.lumifybanner.formStatusError).attr('data-error-text'),
          selectedProduct = '',
          $formObj = $('#lumify-contact-form'),
          url = $formObj.attr('action'),
          storeId = $('#currentStoreId').val().split('-'),
          storeValue = storeId[storeId.length - 1],
          optinNew = 'optinn_new',
          formData = {
            language1: storeValue,
            country: storeValue.toUpperCase(),
            pageurl: window.location.hostname + window.location.pathname,
            pagename: 'Lumify eShop',
            interestprim: 'HC_ULTRA_MOBILE',
            cta: 'request_quotation',
            ac: $formObj.attr('data-form-ac'),
            Followup: 'Price Quote/Demo',
            timeframe: 'Urgent',
            Comments: 'Selected product: ',
            elqCookieWrite: 1,
            elqSiteID: '334834414',
            elqFormName: 704
          };

      if ($formObj.find('#lumify-contact-form-tnc').prop('checked') === false) {
        ACC.lumifybanner.isFormValid = false;
        $formObj.find('.ph-lumify-contact-tnc-empty').removeClass('hidden');
      }

      if ($formObj.find('#lumify-contact-form-newsletter').prop('checked') === true) {
        formData[optinNew] = 'on';
      } else {
        formData[optinNew] = '';
      }

      formData = ACC.lumifybanner.updateFormData(formData, $formObj);
      selectedProduct = ACC.lumifybanner.formValidationRadio('product');
      formData.Comments = formData.Comments + selectedProduct + '\r\n\r\n' + $formObj.find('#lumify-contact-form-comments').val();

      formData.fid = 'contact_followup' + new Date().getTime() + '_' + new Date().getTime();

      ACC.lumifybanner.formValidationInput();

      if (ACC.lumifybanner.isFormValid) {
        $.post(url, formData, function(data, status) {
          $('.ph-lumify-contact-form-contents').addClass('hidden');
          $(ACC.lumifybanner.formStatusClose).removeClass('hidden');

          if (status === 'success') {
            $(ACC.lumifybanner.formStatusSubmit).html(successText + selectedProduct);
          } else {
            $(ACC.lumifybanner.formStatusError).html(errorText);
          }
        });
      }
    });
  },
  formCancel: function() {
    $('.ph-lumify-contact-form-contents__button-cancel, .ph-lumify-contact-form-status-close').click(function() {
      ACC.lumifybanner.formReset();
      $.colorbox.close();
    });
  },
  bannerAdjustIfNoImage: function() {
    if (($('.ph-lumify-banner-img__image').length !== 0) && $('.ph-lumify-banner-img__image').attr('src').length === 0) {
      // Image not loaded. make text span the whole width of banner
      $('.ph-lumify-banner-img__section').hide();
      $('.ph-lumify-banner-header__content').addClass('ph-col-12');
      $('.ph-lumify-banner-header__content').css('min-height', '125px');
      $('.ph-lumify-banner-container').css('margin-left', ' 0px');
    }
  },
  bindAll: function() {
    ACC.lumifybanner.buttonPopup();
    ACC.lumifybanner.bannerAdjustIfNoImage();
  }
};

$(document).ready(function() {
  ACC.lumifybanner.bindAll();
});
